import { createFileRoute } from "@tanstack/react-router";
import DigitalWorkers from "@/pages/DigitalWorkers";
import { pageHead } from "@/lib/seo";
import { agentsItemListJsonLd } from "@/lib/agents";

export const Route = createFileRoute("/digital-workers")({
  head: () => ({
    ...pageHead("/digital-workers", "en"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(agentsItemListJsonLd("en")),
      },
    ],
  }),
  component: DigitalWorkers,
});
